import React, { useState, useEffect } from 'react';
import { apiGet } from '../../api';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';

const ViewUserStatus = () => {
  const location = useLocation();
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (location.state && location.state.username) {
      setUsername(location.state.username);
    }
  }, [location.state]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await apiGet(`/api/admin/user/get-status?username=${username}`);
      if (res.data.success) {
        setStatus(res.data.data.status);
        toast.success('Status fetched successfully');
      } else {
        toast.error(res.data.message || 'Failed to fetch status');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Error fetching status');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-lg mx-auto">
      <h1 className="font-serif italic text-2xl sm:text-3xl text-foreground mb-1">View User Status</h1>
      <p className="text-sm text-muted-foreground mb-6">Look up the current account status for a user.</p>

      <div className="border-t border-white/[0.08] pt-6">
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-1.5">
              Username
            </label>
            <input
              name="username"
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="Enter username"
              className="w-full rounded-md border border-border/70 bg-white/[0.03] px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground/50 focus:border-ginox-green/50 focus:outline-none focus:ring-1 focus:ring-ginox-green/30"
              required
            />
          </div>

          <div className="pt-1">
            <button
              type="submit"
              disabled={loading}
              className="rounded-md border border-ginox-green/60 bg-ginox-green/10 px-4 py-2 text-xs font-medium text-ginox-green hover:bg-ginox-green/20 transition-colors disabled:opacity-50"
            >
              {loading ? 'Fetching...' : 'Get Status'}
            </button>
          </div>
        </form>

        {status && (
          <div className="mt-5 pt-5 border-t border-border/40">
            <dl className="grid grid-cols-1 gap-y-4">
              <div>
                <dt className="text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground">Current Status</dt>
                <dd className="mt-0.5 flex items-center gap-2">
                  <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${
                    status === 'Active'
                      ? 'bg-emerald-500/10 text-emerald-400 border border-emerald-500/20'
                      : 'bg-red-500/10 text-red-400 border border-red-500/20'
                  }`}>
                    {status}
                  </span>
                </dd>
              </div>
            </dl>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewUserStatus;
